import { render } from "./DemoView.vue?vue&type=template&id=e5f2c098&ts=true"
import script from "./DemoView.vue?vue&type=script&lang=ts"
export * from "./DemoView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__